import { Table } from "semantic-ui-react";

export default function TableWrapper(props:any):JSX.Element{
  return (
    <div className="mx-0 my-auto overflow-auto w-full">
      <Table sortable selectable striped unstackable celled structured color="yellow" style={{fontSize:'.95rem'}}>
        {props.children}
      </Table>
    </div>
  )
}
